import UserAccessForm from './UserAccessForm';

export default UserAccessForm;
